import { Button } from "../../../components/ui/button";
import { FaArrowsRotate } from "react-icons/fa6";

interface RefreshButtonProps {
    handleRefresh: () => void;
    disabled?: boolean;
}

/**
 * RefreshButton Component
 *
 * Button to manually refresh/reload report data.
 * Displays rotating arrow icon with "Reincarcare" text.
 *
 * @param handleRefresh - Function to call when refresh is requested
 * @param disabled - Whether the button should be disabled
 */
export default function RefreshButton({ handleRefresh, disabled }: RefreshButtonProps) {
    return (
        <Button onClick={handleRefresh} disabled={disabled} className="hidden sm:flex sm:w-auto">
            <FaArrowsRotate />
            <span className="pl-2">Reincarcare</span>
        </Button>
    );
}
